import { type Agent } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { authorsMatch } from './authorsMatch';
import { deriveBaselineAuthorIdentity } from './deriveBaselineAuthorIdentity';
import type { ResponseAuthorIdentity } from './ResponseAuthorIdentity';

export const agentMatchesAuthor = (
	agent: Agent | undefined,
	author: ResponseAuthorIdentity,
): boolean => authorsMatch(deriveBaselineAuthorIdentity(agent), author);
